module.exports = __webpack_public_path__ + "img/sharp-example7.f2360fec.jpg";